import React from 'react';

const DOCUMENT_CHECKLIST = [
  { icon: 'ID', title: 'Driver License', detail: 'Uploaded Jul 02, 2026.', status: 'Verified', statusClass: 'fg-status-green' },
  { icon: 'SS', title: 'Social Security Card', detail: 'Uploaded Jul 02, 2026.', status: 'Verified', statusClass: 'fg-status-green' },
  { icon: 'EIN', title: 'EIN Confirmation Letter', detail: 'Matched to MS Beauty Studio LLC.', status: 'Verified', statusClass: 'fg-status-green' },
  { icon: 'BS', title: 'Business Bank Statements', detail: 'Need latest 2 months before LOC submission.', status: 'Missing', statusClass: 'fg-status-yellow' },
  { icon: 'POA', title: 'Proof of Address', detail: 'Utility bill, lease, mortgage statement, or bank statement accepted.', status: 'Missing', statusClass: 'fg-status-yellow' },
];

const FundingClientDocumentsTab = () => (
  <div data-testid="funding-documents-tab">
    <div className="fg-document-grid">
      <div className="fg-document-stat">
        <span>Total documents</span>
        <strong>8</strong>
      </div>
      <div className="fg-document-stat">
        <span>Missing documents</span>
        <strong>2</strong>
      </div>
      <div className="fg-document-stat">
        <span>Ready for package</span>
        <strong>75%</strong>
      </div>
    </div>

    <div className="fg-workspace-card">
      <h4>Document Checklist</h4>
      <p>Track every document needed before lender matching, sequencing, and submission.</p>

      <div className="fg-document-list">
        {DOCUMENT_CHECKLIST.map((doc) => (
          <div key={doc.title} className="fg-document-item">
            <div className="fg-item-icon">{doc.icon}</div>
            <div className="fg-item-main">
              <strong>{doc.title}</strong>
              <span>{doc.detail}</span>
            </div>
            <span className={`fg-status-pill ${doc.statusClass}`}>{doc.status}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default FundingClientDocumentsTab;
